import React from 'react'
import ReactDOM from 'react-dom/client'
import reportWebVitals from './reportWebVitals'
import './fonts/NunitoSans.ttf'
import './i18n'
import Customizer from './Customizer'
import { ModalRoot } from './components/ModalPortal/ModalRoot'
import { ToastContainer } from 'react-toastify'
import { AuthContextProvider } from './contexts/AuthContext'
import Backend from './Backend'
import { PluginContextProvider } from './contexts/PluginContext'

const root = ReactDOM.createRoot(
    document.getElementById('zr_customizer_root') as HTMLElement
)

const mode: string | undefined = process.env.REACT_APP_MODE
const context: string | undefined =
    mode === 'production'
        ? window.location.href.includes('/admin/plugin') ||
          window.location.href.includes('/zr-customizer')
            ? 'admin'
            : 'customizer'
        : process.env.REACT_APP_CONTEXT

root.render(
    <PluginContextProvider>
        {context === 'customizer' ? (
            <Customizer />
        ) : (
            <AuthContextProvider>
                <Backend />
            </AuthContextProvider>
        )}
        <ModalRoot />
        <ToastContainer />
    </PluginContextProvider>
)

reportWebVitals()
